<script>
  import * as R from 'ramda';
  import ConductInspectionPageEntityItem from '@/_legacy/components/ConductInspection/ConductInspectionPageEntityItem.vue';

  export default {
    name: 'ConductInspectionPage',
    components: {
      ConductInspectionPageEntityItem,
    },
    props: {
      entities: {
        type: Object,
        required: true,
      },
      page: {
        type: Object,
        required: false,
      },
    },
    computed: {
      isHeaderPage() {
        return this.page ? R.path(['params', 'header'], this.page) : false;
      },
      hasSelectableEntityItems() {
        return (
          this.entities.inspection.entity_items
          && Object.values(this.entities.inspection.entity_items).length > 1
        );
      },
    },
  };
</script>

<template>
  <div class="preview__page">
    <slot></slot>
  </div>
</template>

<style scoped>
.preview__page {
  @apply p-4 bg-white;
}
</style>
